enum WidgetTargetType {
  Range = 'TARGET_RANGE',
  Value = 'SPECIFIC_TARGET',
  None = 'NOT_SET',
}

export default WidgetTargetType;
